import React from 'react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileTimePicker } from '@mui/x-date-pickers/MobileTimePicker';
import {
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
} from '@mui/material';
import { Controller } from 'react-hook-form';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
interface Props {
  id: string;
  label?: string;
  placeholder?: string;
  name: string;
  type?: string;
  helperText?: string;
  error?: boolean;
  disabled?: boolean;
  defaultValue?: string | number;
  variant?: 'outlined' | 'standard' | 'filled' | undefined;
  requiredField?: boolean;
  control: any;
  minutesStep?: number;
  value?: any;
  onChange?: any;
  minSelectableTime?: any;
  validate?: any;
  onClose?: any;
  open?: any;
  onClick?: any;
  date?: any;
}
export default function TimePickerControlled(props: Props) {
  const {
    id,
    label,
    placeholder,
    name,
    type,
    helperText,
    error,
    disabled,
    defaultValue,
    variant,
    requiredField,
    control,
    minutesStep,
    value,
    onChange,
    minSelectableTime = null,
    validate,
    onClose,
    open,
    onClick,
    date,
  } = props;

  return (
    <>
      {control && (
        <Controller
          name={name}
          control={control}
          defaultValue={defaultValue}
          // Set default value to null
          render={({ field }) => (
            <FormControl
              fullWidth
              className={`dateInput ${error ? 'border-red' : ''}`}
              error={error ? true : false}
            >
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <FormLabel className="formLabel">
                  {label} {requiredField ? <sup>*</sup> : null}{' '}
                </FormLabel>
                <MobileTimePicker
                  value={value || null}
                  onAccept={val => {
                    const combined = date
                      .hour(val?.hour())
                      .minute(val?.minute())
                      .second(0)
                      .millisecond(0);

                    if (onChange) onChange(combined); // call external handler if passed
                  }}
                  open={open}
                  onClose={onClose}
                  slotProps={{
                    textField: {
                      // helperText: helperText,
                      onClick: onClick,
                      variant: variant,
                      size: 'small',
                      InputProps: {
                        endAdornment: (
                          <div className="inputEndIcon">
                            <IconButton>
                              <AccessTimeIcon fontSize="small" />
                            </IconButton>
                          </div>
                        ),
                      },
                      placeholder: placeholder ?? 'HH:MM',
                    },
                  }}
                  disabled={disabled}
                  defaultValue={defaultValue || null}
                  minutesStep={minutesStep || 1}
                />
              </LocalizationProvider>
              <FormHelperText className={error ? 'helper-error' : ''}>
                {helperText}
              </FormHelperText>
            </FormControl>
          )}
        />
      )}
    </>
  );
}
